// extracted by mini-css-extract-plugin
module.exports = {"codeVerificationWrapper":"_df1ead8","alertWrapper":"_52cd69e","boldEmail":"_102e8c8","error":"_4d3549e","buttonsWrapper":"_739685f"};